<div class="mat-dialog-strobe-details">
    <form [formGroup]="strobesInputForm">
        <div mat-dialog-title class="dialog-title">
            <h2>{{headerName}} </h2>
            <button mat-icon-button aria-label="close dialog" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content class="mat-typography">
            <div class="device-details-form">
                <mat-grid-list cols="2" rowHeight="80px">
                    <mat-grid-tile *ngIf="!isAddButton">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Strobe Unique ID </mat-label>
                                <input matInput placeholder="Strobe Unique ID" formControlName="strobeuniqueId"
                                    readonly />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.uniqueID}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Name </mat-label>
                                <input matInput placeholder="Name" formControlName="name" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.strobeName}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="isAddButton">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Device Type </mat-label>
                                <mat-select formControlName="deviceType">
                                    <mat-option *ngFor="let deviceTyp of deviceTypsData;"
                                        value="{{deviceTyp.value}}">{{deviceTyp.name}}</mat-option>
                                </mat-select>
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.deviceType}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="isAddButton">
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Device Name </mat-label>
                                <input matInput placeholder="Device Name" formControlName="deviceName"
                                    readonly="{{!isAddButton}}" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.deviceName}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Potential ID </mat-label>
                                <input matInput placeholder="Potential ID" formControlName="potentialId" readonly />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.potentialId}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Strobe ID </mat-label>
                                <input matInput placeholder="Strobe ID" formControlName="strobeId"
                                    readonly="{{!isAddButton}}" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.strobeId}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">IP Address </mat-label>
                                <input matInput placeholder="IP Address" formControlName="ipAddress" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.ipAddress}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Port Number </mat-label>
                                <input matInput placeholder="Port Number" formControlName="portNumber" type="number" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.portNumber}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">User Name </mat-label>
                                <input matInput placeholder="User Name" formControlName="username" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.username}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Password </mat-label>
                                <input matInput [type]="hidePassword ? 'password' : 'text'" placeholder="Password"
                                    formControlName="password" />
                                <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{hidePassword ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.password}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                    <mat-grid-tile>
                        <div class="w-100">
                            <mat-form-field appearance="outline" class="form-feild">
                                <mat-label class="asterix--before">Site Name </mat-label>
                                <input matInput placeholder="Site Name" formControlName="siteName"
                                    readonly="{{!isAddButton}}" />
                                <mat-error *ngIf="strobesInputForm.invalid">
                                    {{errorMessageFormField.siteName}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </mat-grid-tile>
                </mat-grid-list>
                <!-- <div class="nots-text">
                    <span>Note: Changes in parameter value needs server restart.</span>
                </div> -->
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-stroked-button type="submit" *ngIf="isAddButton" class="add-btn"
                (click)="addStrobes()">Add</button>
            <button mat-stroked-button type="submit" *ngIf="!isAddButton" class="update-btn"
                (click)="updateStrobes()">Update</button>
            <button mat-stroked-button [mat-dialog-close]="true">Close</button>
        </mat-dialog-actions>
    </form>
</div>